var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-alert',{attrs:{"border":"left","outlined":"","prominent":"","type":"info"}},[[_c('span',{domProps:{"textContent":_vm._s(_vm.$t('msgs.goldFeature'))}})]],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }